"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignChart = exports.pointInRange = exports.getAxisRangeForAxes = exports.shouldYAxisStartOnTickOnBubbleScatter = exports.shouldXAxisStartOnTickOnBubbleScatter = exports.shouldEndOnTick = exports.shouldStartOnTick = exports.getStackedMinValue = exports.getStackedMaxValue = exports.shouldFollowPointer = exports.shouldFollowPointerForDualAxes = exports.getShapeAttributes = exports.getPointPositions = exports.getChartProperties = exports.isStacked = exports.getChartType = exports.getDataPointsOfVisibleSeries = exports.getDataPoints = exports.getHiddenSeries = exports.getVisibleSeries = exports.toNeighbors = exports.isIntersecting = exports.rectanglesAreOverlapping = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var flatten_1 = tslib_1.__importDefault(require("lodash/flatten"));
var pick_1 = tslib_1.__importDefault(require("lodash/pick"));
var map_1 = tslib_1.__importDefault(require("lodash/map"));
var zip_1 = tslib_1.__importDefault(require("lodash/zip"));
var unzip_1 = tslib_1.__importDefault(require("lodash/unzip"));
var initial_1 = tslib_1.__importDefault(require("lodash/initial"));
var tail_1 = tslib_1.__importDefault(require("lodash/tail"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var maxBy_1 = tslib_1.__importDefault(require("lodash/maxBy"));
var minBy_1 = tslib_1.__importDefault(require("lodash/minBy"));
var min_1 = tslib_1.__importDefault(require("lodash/min"));
var max_1 = tslib_1.__importDefault(require("lodash/max"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var common_1 = require("../_util/common");
var alignments_1 = require("../../constants/alignments");
// https://silentmatt.com/rectangle-intersection/
exports.rectanglesAreOverlapping = function (r1, r2, padding) {
    if (padding === void 0) { padding = 0; }
    return r1.left - padding < r2.right + padding &&
        r1.right + padding > r2.left - padding &&
        r1.top - padding < r2.bottom + padding &&
        r1.bottom + padding > r2.top - padding;
};
exports.isIntersecting = function (r1, r2) {
    return r1.x < r2.x + r2.width && r1.x + r1.width > r2.x && r1.y < r2.y + r2.height && r1.y + r1.height > r2.y;
};
exports.toNeighbors = function (array) { return zip_1.default(initial_1.default(array), tail_1.default(array)); };
exports.getVisibleSeries = function (chart) {
    return chart.series && chart.series.filter(function (s) { return s.visible; });
};
exports.getHiddenSeries = function (chart) {
    return chart.series && chart.series.filter(function (s) { return !s.visible; });
};
exports.getDataPoints = function (series) {
    return compact_1.default(flatten_1.default(unzip_1.default(map_1.default(series, function (s) { return s.points; }))));
};
exports.getDataPointsOfVisibleSeries = function (chart) {
    return exports.getDataPoints(exports.getVisibleSeries(chart));
};
exports.getChartType = function (chart) { var _a; return (_a = chart.options.chart) === null || _a === void 0 ? void 0 : _a.type; };
exports.isStacked = function (chart) {
    var _a, _b, _c, _d, _e, _f;
    var chartType = exports.getChartType(chart);
    if (((_c = (_b = (_a = chart.userOptions) === null || _a === void 0 ? void 0 : _a.plotOptions) === null || _b === void 0 ? void 0 : _b[chartType]) === null || _c === void 0 ? void 0 : _c.stacking) &&
        chart.axes.some(function (axis) { var _a; return !isEmpty_1.default((_a = axis === null || axis === void 0 ? void 0 : axis.stacking) === null || _a === void 0 ? void 0 : _a.stacks); })) {
        return true;
    }
    if (((_f = (_e = (_d = chart.userOptions) === null || _d === void 0 ? void 0 : _d.plotOptions) === null || _e === void 0 ? void 0 : _e.series) === null || _f === void 0 ? void 0 : _f.stacking) &&
        chart.axes.some(function (axis) { var _a; return !isEmpty_1.default((_a = axis === null || axis === void 0 ? void 0 : axis.stacking) === null || _a === void 0 ? void 0 : _a.stacks); })) {
        return true;
    }
    return false;
};
function getChartProperties(config, type) {
    var isInvertedType = common_1.isInvertedChartType(type);
    var chartProps = {
        xAxisProps: isInvertedType ? tslib_1.__assign({}, config.yaxis) : tslib_1.__assign({}, config.xaxis),
        yAxisProps: isInvertedType ? tslib_1.__assign({}, config.xaxis) : tslib_1.__assign({}, config.yaxis),
    };
    var secondaryXAxisProps = isInvertedType
        ? tslib_1.__assign({}, config.secondary_yaxis) : tslib_1.__assign({}, config.secondary_xaxis);
    var secondaryYAxisProps = isInvertedType
        ? tslib_1.__assign({}, config.secondary_xaxis) : tslib_1.__assign({}, config.secondary_yaxis);
    if (!isEmpty_1.default(secondaryXAxisProps)) {
        chartProps.secondary_xAxisProps = secondaryXAxisProps;
    }
    if (!isEmpty_1.default(secondaryYAxisProps)) {
        chartProps.secondary_yAxisProps = secondaryYAxisProps;
    }
    return chartProps;
}
exports.getChartProperties = getChartProperties;
exports.getPointPositions = function (
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
point) {
    var dataLabel = point.dataLabel, graphic = point.graphic;
    var labelRect = dataLabel.element.getBoundingClientRect();
    var shapeRect = graphic.element.getBoundingClientRect();
    return {
        shape: shapeRect,
        label: labelRect,
        labelPadding: dataLabel.padding,
        show: function () { return dataLabel.show(); },
        hide: function () { return dataLabel.hide(); },
    };
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getShapeAttributes(point) {
    var series = point.series, shapeArgs = point.shapeArgs;
    var _a = series.chart, plotSizeX = _a.plotSizeX, plotSizeY = _a.plotSizeY, options = _a.options;
    if (options.chart.type === sdk_ui_1.VisualizationTypes.BAR) {
        return {
            x: Math.floor(plotSizeY - (shapeArgs.y - series.group.translateX) - shapeArgs.height),
            y: Math.ceil(plotSizeX + series.group.translateY - shapeArgs.x - shapeArgs.width),
            width: shapeArgs.height,
            height: shapeArgs.width,
        };
    }
    else if (options.chart.type === sdk_ui_1.VisualizationTypes.COLUMN) {
        return {
            x: shapeArgs.x + series.group.translateX,
            y: shapeArgs.y + series.group.translateY,
            width: shapeArgs.width,
            height: shapeArgs.height,
        };
    }
    return {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    };
}
exports.getShapeAttributes = getShapeAttributes;
function getExtremeOnAxis(min, max) {
    var axisMin = min >= 0 ? 0 : min;
    var axisMax = max < 0 ? 0 : max;
    return { axisMin: axisMin, axisMax: axisMax };
}
function shouldFollowPointerForDualAxes(chartOptions) {
    var _a, _b, _c, _d, _e;
    var yAxes = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.yAxes) !== null && _a !== void 0 ? _a : [];
    if (yAxes.length <= 1) {
        return false;
    }
    var hasMinMaxValue = [
        (_b = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.yAxisProps) === null || _b === void 0 ? void 0 : _b.min,
        (_c = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.yAxisProps) === null || _c === void 0 ? void 0 : _c.max,
        (_d = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.secondary_yAxisProps) === null || _d === void 0 ? void 0 : _d.min,
        (_e = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.secondary_yAxisProps) === null || _e === void 0 ? void 0 : _e.max,
    ].some(function (item) { return !isEmpty_1.default(item); });
    return yAxes.length > 1 && hasMinMaxValue;
}
exports.shouldFollowPointerForDualAxes = shouldFollowPointerForDualAxes;
function isMinMaxLimitData(chartOptions, key) {
    var _a, _b, _c, _d;
    var yMin = parseFloat((_b = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions[key]) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : "");
    var yMax = parseFloat((_d = (_c = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions[key]) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : "");
    if (isNaN(yMin) && isNaN(yMax)) {
        return false;
    }
    var _e = getDataExtremeDataValues(chartOptions), minDataValue = _e.minDataValue, maxDataValue = _e.maxDataValue;
    var _f = getExtremeOnAxis(minDataValue, maxDataValue), axisMin = _f.axisMin, axisMax = _f.axisMax;
    return (!isNaN(yMax) && axisMax > yMax) || (!isNaN(yMin) && axisMin < yMin);
}
function shouldFollowPointer(chartOptions) {
    if (shouldFollowPointerForDualAxes(chartOptions)) {
        return true;
    }
    return (isMinMaxLimitData(chartOptions, "yAxisProps") ||
        isMinMaxLimitData(chartOptions, "secondary_yAxisProps"));
}
exports.shouldFollowPointer = shouldFollowPointer;
function isSerieVisible(serie) {
    return serie.visible === undefined || serie.visible;
}
function getNonStackedMaxValue(series) {
    return series.reduce(function (maxValue, serie) {
        if (isSerieVisible(serie)) {
            var maxSerieValue = getSerieMaxDataValue(serie.data);
            return maxValue > maxSerieValue ? maxValue : maxSerieValue;
        }
        return maxValue;
    }, Number.MIN_SAFE_INTEGER);
}
function getNonStackedMinValue(series) {
    return series.reduce(function (minValue, serie) {
        if (isSerieVisible(serie)) {
            var minSerieValue = getSerieMinDataValue(serie.data);
            return minValue < minSerieValue ? minValue : minSerieValue;
        }
        return minValue;
    }, Number.MAX_SAFE_INTEGER);
}
function getDataExtremeDataValues(chartOptions) {
    var _a;
    var series = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.data) === null || _a === void 0 ? void 0 : _a.series;
    var maxDataValue = chartOptions.hasStackByAttribute
        ? getStackedMaxValue(series)
        : getNonStackedMaxValue(series);
    var minDataValue = chartOptions.hasStackByAttribute
        ? getStackedMinValue(series)
        : getNonStackedMinValue(series);
    return { minDataValue: minDataValue, maxDataValue: maxDataValue };
}
function getSerieMaxDataValue(serieData) {
    var max = maxBy_1.default(serieData, function (item) { return (item && item.y ? item.y : null); });
    return max ? max.y : Number.MIN_SAFE_INTEGER;
}
function getSerieMinDataValue(serieData) {
    var min = minBy_1.default(serieData, function (item) { return (item && item.y ? item.y : null); });
    return min ? min.y : Number.MAX_SAFE_INTEGER;
}
function getStackedMaxValue(series) {
    var maximumPerColumn = getColumnExtremeValue(series, getMaxFromPositiveNegativeStacks);
    var maxValue = max_1.default(maximumPerColumn);
    return !isNil_1.default(maxValue) ? maxValue : Number.MIN_SAFE_INTEGER;
}
exports.getStackedMaxValue = getStackedMaxValue;
function getStackedMinValue(series) {
    var minimumPerColumn = getColumnExtremeValue(series, getMinFromPositiveNegativeStacks);
    var minValue = min_1.default(minimumPerColumn);
    return !isNil_1.default(minValue) ? minValue : Number.MAX_SAFE_INTEGER;
}
exports.getStackedMinValue = getStackedMinValue;
function getColumnExtremeValue(series, extremeColumnGetter) {
    var seriesDataPerColumn = zip_1.default.apply(void 0, series.filter(isSerieVisible).map(function (serie) { return serie.data; }));
    var seriesDataYValue = seriesDataPerColumn.map(function (data) { return data.map(function (x) { return x.y; }); });
    return seriesDataYValue.map(extremeColumnGetter);
}
function getMaxFromPositiveNegativeStacks(data) {
    return data.reduce(function (acc, current) {
        if (isNil_1.default(current)) {
            return acc;
        }
        if (current < 0 || acc < 0) {
            return Math.max(acc, current);
        }
        return acc + current;
    }, Number.MIN_SAFE_INTEGER);
}
function getMinFromPositiveNegativeStacks(data) {
    return data.reduce(function (acc, current) {
        if (isNil_1.default(current)) {
            return acc;
        }
        if (current > 0 || acc > 0) {
            return Math.min(acc, current);
        }
        return acc + current;
    }, Number.MAX_SAFE_INTEGER);
}
function shouldStartOnTick(chartOptions, axisPropsKey) {
    var _a, _b, _c, _d, _e;
    if (axisPropsKey === void 0) { axisPropsKey = "yAxisProps"; }
    var min = parseFloat((_b = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions[axisPropsKey]) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : "");
    var max = parseFloat((_d = (_c = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions[axisPropsKey]) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : "");
    if (isNaN(min) && isNaN(max)) {
        return true;
    }
    if (!isNaN(min) && !isNaN(max)) {
        return min > max;
    }
    var series = (_e = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.data) === null || _e === void 0 ? void 0 : _e.series;
    var minDataValue = chartOptions.hasStackByAttribute
        ? getStackedMinValue(series)
        : getNonStackedMinValue(series);
    var hasIncorrectMax = !isNaN(max) && max <= minDataValue;
    if (hasIncorrectMax) {
        return true;
    }
    return false;
}
exports.shouldStartOnTick = shouldStartOnTick;
function shouldEndOnTick(chartOptions, axisPropsKey) {
    var _a, _b, _c, _d, _e;
    if (axisPropsKey === void 0) { axisPropsKey = "yAxisProps"; }
    var min = parseFloat((_b = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions[axisPropsKey]) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : "");
    var max = parseFloat((_d = (_c = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions[axisPropsKey]) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : "");
    if (isNaN(min) && isNaN(max)) {
        return true;
    }
    if (!isNaN(min) && !isNaN(max)) {
        return min > max;
    }
    var series = (_e = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.data) === null || _e === void 0 ? void 0 : _e.series;
    var maxDataValue = chartOptions.hasStackByAttribute
        ? getStackedMaxValue(series)
        : getNonStackedMaxValue(series);
    var hasIncorrectMin = !isNaN(min) && min >= maxDataValue;
    if (hasIncorrectMin) {
        return true;
    }
    return false;
}
exports.shouldEndOnTick = shouldEndOnTick;
function shouldXAxisStartOnTickOnBubbleScatter(chartOptions) {
    var _a, _b;
    var min = parseFloat((_b = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.xAxisProps) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : "");
    return isNaN(min) ? true : false;
}
exports.shouldXAxisStartOnTickOnBubbleScatter = shouldXAxisStartOnTickOnBubbleScatter;
function shouldYAxisStartOnTickOnBubbleScatter(chartOptions) {
    var _a, _b, _c;
    var min = parseFloat((_b = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.yAxisProps) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : "");
    var series = (_c = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.data) === null || _c === void 0 ? void 0 : _c.series;
    var maxDataValue = getNonStackedMaxValue(series);
    return isNaN(min) || min > maxDataValue ? true : false;
}
exports.shouldYAxisStartOnTickOnBubbleScatter = shouldYAxisStartOnTickOnBubbleScatter;
function getAxisRangeForAxes(chart) {
    var yAxis = chart.yAxis;
    // note: accessing 'opposite' prop which is not part of the public API; min & max is
    return yAxis
        .map(function (axis) { return pick_1.default(axis, ["opposite", "min", "max"]); })
        .map(function (_a) {
        var opposite = _a.opposite, min = _a.min, max = _a.max;
        return ({ axis: opposite ? "second" : "first", min: min, max: max });
    })
        .reduce(function (result, _a) {
        var axis = _a.axis, min = _a.min, max = _a.max;
        result[axis] = {
            minAxisValue: min,
            maxAxisValue: max,
        };
        return result;
    }, {});
}
exports.getAxisRangeForAxes = getAxisRangeForAxes;
function pointInRange(pointValue, axisRange) {
    return axisRange.minAxisValue <= pointValue && pointValue <= axisRange.maxAxisValue;
}
exports.pointInRange = pointInRange;
function alignChart(chart, verticalAlign) {
    if (verticalAlign === void 0) { verticalAlign = "middle"; }
    var container = chart.container;
    if (!container) {
        return;
    }
    var _a = container.getBoundingClientRect(), chartWidth = _a.width, chartHeight = _a.height;
    var margin = chartHeight - chartWidth;
    var isVerticalRectContainer = margin > 0;
    var isAlignedToTop = verticalAlign === alignments_1.TOP;
    var isAlignedToBottom = verticalAlign === alignments_1.BOTTOM;
    var type = exports.getChartType(chart);
    var className = "s-highcharts-" + type + "-aligned-to-" + verticalAlign;
    var chartOptions = {};
    if (isVerticalRectContainer && verticalAlign !== alignments_1.MIDDLE) {
        chartOptions = {
            spacingTop: isAlignedToTop ? 0 : undefined,
            spacingBottom: isAlignedToBottom ? 0 : undefined,
            marginTop: isAlignedToBottom ? margin : undefined,
            marginBottom: isAlignedToTop ? margin : undefined,
            className: className,
        };
    }
    else {
        chartOptions = {
            spacingTop: undefined,
            spacingBottom: undefined,
            marginTop: undefined,
            marginBottom: undefined,
            className: className,
        };
    }
    chart.update({
        chart: chartOptions,
    }, false, false, false);
}
exports.alignChart = alignChart;
//# sourceMappingURL=helpers.js.map